import PassRecovery from './PassRecovery';

export default PassRecovery;
